export default "__VITE_ASSET__cUz_kuRD__"